// extracted by mini-css-extract-plugin
export default {"stripeText":"H58uf","tickerWrap":"ikCan","ticker":"S8b93"};